import React from "react";
import { AccessibilityPopup } from '@skillz/accessibility';
import ScrollLTR from "../../scrollLTR/ScrollLTR";
import classes from "./ContentPopup.module.css"

const ContentsPopup = ({ children, className, accessibilityDescription, scrollDropClass, scrollContentClass }) => {

    return (
        <AccessibilityPopup accessibilityDescription={accessibilityDescription} close={() => console.log('close')}>
            <ScrollLTR dropClass={scrollDropClass} downDropStyle={scrollContentClass}>
                <div className={`${classes.ContentsPopup} ${className}`} >
                    {children}
                </div>
            </ScrollLTR >
        </AccessibilityPopup>
    )
}

export default ContentsPopup;